export default {
  title: 'Create new contact',
  backButton: 'All contacts',
};
